const SemVerGte = require('semver/functions/gte')

angular
  .module('surfsightApp.controllers')
  .controller('edgeRecordingsListControllerDeprecated', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      leafletData,
      nominatimLookUp,
      $stateParams
    ) {
      $scope.selectedCameraName = $filter('translate')('frontCamera')
      $scope.selectedCameraId = 1
      $scope.totalRecordings = []
      var edge_id = $stateParams.edge_id
      const deviceId = parseInt(edge_id)
      $scope.old_device = false
      $scope.timelineInfo = {
        canShowTimeline: false
      }
      var $translate = $filter('translate')
      var timeFormat = 2

      if ($localStorage.timeFormat) {
        timeFormat = $localStorage.timeFormat
      }
      var mdDateTimePicker = require('md-date-time-picker')
      var z = new mdDateTimePicker.default({
        type: 'date',
        orientation: 'PORTRAIT',
        trigger: document.getElementById('date'),
        init: moment(new Date(), 'YYYY-MM-DD')
      })
      var c = new mdDateTimePicker.default({
        type: 'time',
        init: moment(new Date(), 'H:m'),
        mode: true,
        orientation: 'PORTRAIT',
        trigger: document.getElementById('time')
      })
      $scope.selectDate = function () {
        if (c && c.isOpen()) {
          c.hide()
        }
        z.toggle()
      }
      $scope.selectTime = function () {
        if (z && z.isOpen()) {
          z.hide()
        }
        c.toggle()
      }
      z.trigger.addEventListener('onOk', function () {
        $scope.selectedDate = z.time.format('ddd, MMM D YYYY')
        $scope.$apply()
      })
      c.trigger.addEventListener('onOk', function () {
        $scope.selectedTime = c.time.format('HH:mm')
        if (timeFormat == 2) {
          $scope.selectedTime = c.time.format('LT')
        }
        $scope.$apply()
      })
      $scope.selectedTime = c.time.format('HH:mm')
      if (timeFormat == 2) {
        $scope.selectedTime = c.time.format('LT')
      }

      $scope.selectedDate = z.time.format('ddd, MMM D YYYY')
      const getDeviceSematicVersion = serialNumber => {
        const requestJson = {
          method: 'GET',
          url: `${DEVICEMANAGER_BASEURL}/device/${serialNumber}/diagnostics`
        }
        $http(requestJson).then(response => {
          const deviceSemanticVersion =
            response.data.system_version.semantic_version
          $scope.timelineInfo.canShowTimeline = SemVerGte(
            deviceSemanticVersion,
            window.CAN_PLAY_RECORDING_STREAM_VERSION
          )
        })
      }
      let [edge] = edgeFactory.list.filter(e => e.id === deviceId)
      $scope.edge = edge
      if ($scope.edge) {
        $scope.serialNumber = $scope.edge.uri
        loadData()
      } else {
        $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', { id: deviceId })
        $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', function (e, data) {
          if (data.id === deviceId) {
            ;[edge] = edgeFactory.list.filter(e => e.id === deviceId)
            $scope.edge = edge
            $scope.serialNumber = $scope.edge.uri
            loadData()
          }
        })
      }
      $scope.showTimeline = () => {
        $state.go('home.common.recordings.timeline', { deviceId })
      }
      function loadData () {
        getDeviceSematicVersion($scope.edge.uri)
        $scope.resetRecordingSearch = function () {
          $scope.RecordingSearch = {
            id: 1,
            name: Date.today().toString('dddd, dd MMM yyyy'),
            name_formate1: 'today',
            name_formate2: Date.today().toString('MMM dd '),
            date: {
              start: 0,
              end: Date.today()
                .add(1)
                .day()
                .getTime()
            }
          }
        }
        $scope.recordings = {}
        $scope.resetRecordingSearch()
        $scope.recordings.recordings_array = []
        $scope.loading = false
        $scope.getEdgeRecordings = function (
          last_know_id,
          number_of_records,
          edge,
          isInitial = false
        ) {
          $scope.loading = true
          var edge_id = edge.id
          $scope.selected_gps_events_edge = edge
          const start = moment(
            $scope.selectedDate + ' ' + $scope.selectedTime,
            'ddd, MMM D YYYY HH:mm' + (timeFormat === 2 ? ' A' : '')
          ).toISOString()
          const end = moment(start)
            .add(15, 'minutes')
            .toISOString()
          var data = {
            last_know_id: 0,
            number_of_records: 0,
            time_range: {
              start,
              end
            }
          }
          $scope.recordings_old(edge_id, data)
        }
        $scope.recordings_old = function (edgeId, data) {
          var requestJson = {
            method: 'POST',
            url: EDGE_BASEURL + '/edge/' + edgeId + '/recordings',
            data: data
          }
          $http(requestJson).then(
            function (response) {
              $scope.loading = false
              if (response.data.status.code === 0) {
                const recordings_array = response.data.recordings.map(function (
                  recording,
                  index
                ) {
                  recording.camera_name = window.getCameraNameByStreamId(
                    $filter('translate'),
                    edge,
                    recording.camera_id ? parseInt(recording.camera_id) : 1
                  )
                  const recordingTimeDate = window.recordingFileToDate(
                    recording.file_utc || recording.file
                  )
                  recording.time_string_format = moment(
                    recordingTimeDate
                  ).format(
                    `${timeFormat === 1 ? 'HH:mm:ss' : 'h:mm:ss a'} MMM DD YYYY`
                  )
                  return recording
                })
                $scope.totalRecordings = $scope.recordings.recordings_array.concat(
                  recordings_array
                )
                $scope.selectCamera(
                  $scope.selectedCameraId,
                  $scope.selectedCameraName
                )
              } else {
              }
            },
            function () {
              $scope.loading = false
            }
          )
        }
        $scope.timeout_timer = null
        var isInitial = true
        $scope.isInitial = true
        $scope.loadMore = function () {
          $scope.recordings.recordings_array = []
          $scope.totalRecordings = []
          if ($scope.timeout_timer) {
            $timeout.cancel($scope.timeout_timer)
          }
          if ($scope.loading) {
            return // already loading in progress
          }
          $scope.timeout_timer = $timeout(function () {
            var last_known_id = $scope.last_known_id
            $scope.getEdgeRecordings(last_known_id, 10, edge, isInitial)
            isInitial = false
            $scope.isInitial = false
            $scope.timeout_timer = null
          }, 200)
        }
        $scope.showRecordingDateFilter = function (ev) {
          $mdDialog
            .show({
              controller: 'EdgeRecordingDateFilter',
              templateUrl:
                './templates/edge.recording.date.filter.view.html?t=' +
                window.webpackHash,
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            })
            .then(
              function (response) {
                $scope.RecordingSearch = response
                $scope.recordings.recordings_array = []
                $scope.last_known_id = 0
                $scope.loadMore()
              },
              function () {
                //
              }
            )
        }
        $scope.hideRecordingsSidenav = function () {
          $scope.$emit('hideRecordingsSidenav', {})
          $state.go('home.common.recordings')
        }
        $scope.showARecordingVideo = function (recording, ev) {
          if (!$scope.edge.proxy_connected) {
            $scope.showMessageToast(
              $translate('theDeviceIsOfflineAndRecordingIsNotAvailable')
            )
            return false
          }
          // open a dialog for showing the recording.
          $mdDialog
            .show({
              locals: {
                dataFromCaller: {
                  recording: angular.copy(recording),
                  edge: angular.copy($scope.edge)
                }
              },
              controller: 'EdgeRecordingVideoController',
              templateUrl:
                './templates/edge.recording.video.view.html?t=' +
                window.webpackHash,
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            })
            .then(
              response => {
                if (response === 'timeout') {
                  $scope.showMessageToast(
                    $translate(
                      'unableToDownloadTheFileFromTheCameraPleaseTryAgain'
                    )
                  )
                }
              },
              response => {
                console.error(response)
              }
            )
        }
      }

      $scope.selectCamera = function (
        selectedCameraId,
        selectedCameraName,
        doTranslation,
        index
      ) {
        $scope.selectedCameraName = doTranslation
          ? $filter('translate')(selectedCameraName)
          : selectedCameraName ||
            `${$filter('translate')('auxiliaryCamera')}${
              index !== -1 ? ' ' + (index + 1) : ''
            }`
        $scope.selectedCameraId = selectedCameraId
        $scope.recordings.recordings_array = []
        $scope.totalRecordings.forEach(function (rec) {
          if (rec.camera_id === selectedCameraId) {
            $scope.recordings.recordings_array.push(rec)
          }
        })
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .actionKey('F1')
          .action($translate('ok'))
          .position('top right')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
            }
          })
          .catch(() => {})
      }
      $scope.$on('languageChange', function (e, data) {
        moment.locale(data.response.lang_code.toLowerCase())
        z = new mdDateTimePicker.default({
          type: 'date',
          orientation: 'PORTRAIT',
          trigger: document.getElementById('date'),
          init: moment(new Date(), 'YYYY-MM-DD')
        })
        c = new mdDateTimePicker.default({
          type: 'time',
          init: moment(new Date(), 'H:m'),
          mode: true,
          orientation: 'PORTRAIT',
          trigger: document.getElementById('time')
        })
        $scope.selectedTime = c.time.format('HH:mm')
        if (timeFormat == 2) {
          $scope.selectedTime = c.time.format('LT')
        }
        $scope.selectedDate = z.time.format('ddd, MMM D YYYY')
      })
      $scope.$on('$destroy', () => {
        c.hide()
        z.hide()
      })
    }
  ])
